// src/components/Contact.js
import React from 'react';
import {
  FaLinkedin,
  FaFacebook,
  FaInstagramSquare,
  FaTwitter,
} from "react-icons/fa";
import "./Contact.css"
function Contact() {
  return (
<div className='contact'>
   <div className='contact-form'>
     <h1>Contact <span>Us</span></h1>
     <p>HEY ,Myself Harsh Founder and CEO at TechCross Startup Private Ltd. Contact with me phone: +91 9893783340 or email :helpfromharsh@gmail.com</p>
     <form>
      <input type='' placeholder='Your Name' required/>
      <input type='email' name='email' id="" placeholder='E-mail' required/>4
      <input type='' placeholder='Write a Subject' required/>
      <textarea name='' id='' cols="30" rows="10" placeholder='Your Message' className='textare-text'></textarea> 
      <input type='submit' name="" value="Submit" className='submit-btn'/>
      <div className='faicons'>
      <FaFacebook className='font-icons'/> 
      <FaLinkedin className='font-icons'/>
      <FaInstagramSquare className='font-icons'/>
      <FaTwitter className='font-icons'/>
      </div>
     </form>
   </div>
   <div className='contact-image'>
    <img src={process.env.PUBLIC_URL + "/user.jpg"} alt="image not available" className='contact-pic'/>
   </div>
</div>
  );
}

export default Contact;
